import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { createRequestPowerPlayerWindowOutbound } from '../../../api/outbound/commonOutbounds';
import { isConfigFlagEnabled } from '../../../config';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { thunkCloseCurrentMessageBox } from '../../../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { PLAYER_SERVER_SETTING_PROPERTIES, PLAYER_SERVER_SETTING_TYPES } from '../../../types/playerServerSettingsTypes';
import { OpenModalContainer } from '../../openModalContainer';
import { GoToAccountModalHeaderButton } from '../goToAccountModalHeaderButton';
import { ExperimentalSettingsContainer } from './experimentalSettingsContainer';
import { PanelPositionSettingModalItem } from './panelPositionSettingModalItem';
import { SettingModalItem } from './settingModalItem';
import { ThemeSettingsContainer } from './themeSettingsContainer';
export const SettingsModal = ({ onClose }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const isPowerPlayer = useAppSelector((state) => state.selfData.isPowerPlayer);
    const onClickPowerPlayer = useCallback(() => {
        dispatch(thunkCloseCurrentMessageBox());
        socketSend(createRequestPowerPlayerWindowOutbound());
    }, [dispatch, socketSend]);
    return (_jsx(OpenModalContainer, { title: 'Settings', onClose: onClose, maxWidth: 'md', additionalControls: _jsx(GoToAccountModalHeaderButton, { onClose: onClose }), children: _jsxs(DialogContent, { children: [!isPowerPlayer && (_jsx("div", { css: css `
              margin-bottom: 5px;
            `, children: _jsxs(Typography, { component: 'div', children: ["Some features require", ' ', _jsx(Button, { variant: 'outlined', size: 'small', onClick: onClickPowerPlayer, children: "Power Player" }), "."] }) })), PLAYER_SERVER_SETTING_TYPES.map((settingType) => {
                    const { isDisabled, showInSettingsModal } = PLAYER_SERVER_SETTING_PROPERTIES[settingType];
                    if (isDisabled) {
                        return null;
                    }
                    if (!showInSettingsModal) {
                        return null;
                    }
                    return _jsx(SettingModalItem, { onClose: onClose, settingType: settingType }, settingType);
                }), isConfigFlagEnabled('columnLayoutMode') && _jsx(PanelPositionSettingModalItem, { onClose: onClose }), _jsx(ThemeSettingsContainer, {}), _jsx(ExperimentalSettingsContainer, {})] }) }));
};
